import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders, getHeadersForCsv } from "../../utils/AuthorizationUtil";
import {
  BASE_PRICING_URL,
  BASE_URL,
  REPORTING_BASE_URL,
} from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class NscReportingClient {
  static baseUrl = BASE_URL;
  static pricingUrl = BASE_PRICING_URL;
  static reportingUrl = REPORTING_BASE_URL;

  static downloadDealerActivationReportInCsv(user, selectedMarket) {
    const url = `${this.baseUrl}/${
      user.userType === "nsc"
        ? `nsc/${selectedMarket}`
        : user.generateResourcePath()
    }/activation-report`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDealerReservationSummary(user, market, catalog) {
    let url = `${this.baseUrl}/reports/reservation-summary-report?market=${market}`;
    if (catalog) url = url + `&catalog=${catalog}`;

    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadPricingReport(user, selectedMarket) {
    const url = `${this.pricingUrl}/${
      user.userType === "nsc"
        ? `nsc/${selectedMarket}`
        : user.generateResourcePath()
    }/pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadTransparentPricingReport(user, selectedMarket) {
    const url = `${this.reportingUrl}/reporting/${
      user.userType === "nsc"
        ? `nsc/${selectedMarket}`
        : user.generateResourcePath()
    }/transparent-pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadTransparentAccessoriesPricingReport(user, selectedMarket) {
    const url = `${this.reportingUrl}/reporting/${
      user.userType === "nsc"
        ? `nsc/${selectedMarket}`
        : user.generateResourcePath()
    }/transparent-accessories-pricing-report`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeadersForCsv(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDealerDeliveryRangesInCsv(user, selectedMarket) {
    const url = `${this.baseUrl}/${
      user.userType === "nsc"
        ? `nsc/${selectedMarket}`
        : user.generateResourcePath()
    }/delivery-ranges-report`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadDealerReservationReportInXlsx(user, selectedMarket) {
    const requestBody = {
      userType: user.userType,
      marketId: selectedMarket,
      filterData: false,
    };

    const url = `${this.reportingUrl}/reporting/${selectedMarket}/eu-reservations-report`;

    return axios
      .post(url, requestBody, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
